import React, { useEffect, useRef, useState } from "react";
import { FaGlobe } from "react-icons/fa";

const LanguageSelector: React.FC = () => {
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const [lang, setLang] = useState("en");
  const langRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const storedLang = localStorage.getItem("lang") || "en";
    setLang(storedLang);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (langRef.current && !langRef.current.contains(e.target as Node)) {
        setLangMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changeLanguage = (selectedLang: string) => {
    localStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
    setLangMenuOpen(false);
    window.location.reload(); // optional: reload to reflect changes
  };

  return (
    <div className="relative" ref={langRef}>
      <button
        onClick={() => setLangMenuOpen(!langMenuOpen)}
        className="flex items-center text-lg text-gray-800 hover:text-gray-600"
        title="Select Language"
      >
        <FaGlobe />
        <span className="ml-2">{lang.toUpperCase()}</span>
      </button>
      {langMenuOpen && (
        <div className="absolute right-0 mt-2 w-24 bg-white shadow-lg rounded-md z-10">
          <button
            onClick={() => changeLanguage("en")}
            className={`block w-full px-4 py-2 text-left ${lang === "en" ? "bg-gray-100 font-bold" : ""}`}
          >
            EN
          </button>
          <button
            onClick={() => changeLanguage("mk")}
            className={`block w-full px-4 py-2 text-left ${lang === "mk" ? "bg-gray-100 font-bold" : ""}`}
          >
            MK
          </button>
          <button
            onClick={() => changeLanguage("sq")}
            className={`block w-full px-4 py-2 text-left ${lang === "sq" ? "bg-gray-100 font-bold" : ""}`}
          >
            SQ
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
